export class HeatmapBaseRenderer {
}
